// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"I3-z","colorTextValue":"J3-z","swatches":"K3-z","collapseLink":"L3-z","isCollapsed":"M3-z","dropdown":"N3-z","disabled":"O3-z"};